<script setup>

</script>
<template>
  <i class="aside-menu mail-type">
    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_284_210)">
        <path d="M11 18.3333H6C5.46957 18.3333 4.96086 18.1577 4.58579 17.8452C4.21071 17.5326 4 17.1087 4 16.6667V3.33333C4 2.89131 4.21071 2.46738 4.58579 2.15482C4.96086 1.84226 5.46957 1.66667 6 1.66667H13L20 7.5V9.58333" stroke="url(#paint0_linear_284_210)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13 1.66667V7.5H20" stroke="url(#paint1_linear_284_210)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.2 15.92L17 18.72L19.8 15.92" stroke="url(#paint2_linear_284_210)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17 18.72V12" stroke="url(#paint3_linear_284_210)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_284_210" x1="12" y1="1.66667" x2="12" y2="18.3333" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A50BFF"/>
          <stop offset="1" stop-color="#B435FF"/>
        </linearGradient>
        <linearGradient id="paint1_linear_284_210" x1="16.5" y1="1.66667" x2="16.5" y2="7.5" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A50BFF"/>
          <stop offset="1" stop-color="#B435FF"/>
        </linearGradient>
        <linearGradient id="paint2_linear_284_210" x1="17" y1="15.92" x2="17" y2="18.72" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A50BFF"/>
          <stop offset="1" stop-color="#B435FF"/>
        </linearGradient>
        <linearGradient id="paint3_linear_284_210" x1="17.5" y1="12" x2="17.5" y2="18.72" gradientUnits="userSpaceOnUse">
          <stop stop-color="#A50BFF"/>
          <stop offset="1" stop-color="#B435FF"/>
        </linearGradient>
        <clipPath id="clip0_284_210">
          <rect width="24" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
</i>
</template>
<style scoped>

</style>